import {
  getMilestones as getMilestonesService,
  getMilestoneDetails as getMilestoneDetailsService,
  createMilestone as createMilestoneService,
  updateMilestone as updateMilestoneService,
} from "services/company/projectManagement/milestone/milestoneService";
import {
  getMilestonesStart,
  getMilestonesSuccess,
  getMilestonesFailure,
  getMilestoneDetailsStart,
  getMilestoneDetailsSuccess,
  getMilestoneDetailsFailure,
  createMilestoneStart,
  createMilestoneSuccess,
  createMilestoneFailure,
  updateMilestoneStart,
  updateMilestoneSuccess,
  updateMilestoneFailure,
} from "./milestoneSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all milestones for a project
export const fetchMilestones = (projectId) => async (dispatch) => {
  try {
    dispatch(getMilestonesStart());
    const response = await getMilestonesService(projectId);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getMilestonesSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch milestones";
      dispatch(getMilestonesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch milestones error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch milestones";
    dispatch(getMilestonesFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Fetch a single milestone's full details
export const fetchMilestoneDetails = (milestoneId) => async (dispatch) => {
  try {
    dispatch(getMilestoneDetailsStart());
    const response = await getMilestoneDetailsService(milestoneId);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getMilestoneDetailsSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to fetch milestone details";
      dispatch(getMilestoneDetailsFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch milestone details error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch milestone details";
    dispatch(getMilestoneDetailsFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new milestone
export const createNewMilestone = (milestoneData) => async (dispatch) => {
  try {
    dispatch(createMilestoneStart());
    const response = await createMilestoneService(milestoneData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createMilestoneSuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Milestone created successfully!",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create milestone";
      dispatch(createMilestoneFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create milestone error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create milestone";
    dispatch(createMilestoneFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

export const updateExistingMilestone =
  (milestoneId, milestoneData) => async (dispatch) => {
    try {
      dispatch(updateMilestoneStart());
      const response = await updateMilestoneService(milestoneId, milestoneData);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(updateMilestoneSuccess(response.data));
        showSuccessToast(
          response?.meta?.message || "Milestone updated successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg = response?.meta?.message || "Failed to update milestone";
        dispatch(updateMilestoneFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update milestone error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update milestone";
      dispatch(updateMilestoneFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };
